export enum WebsocketEventType {
    ACCESS_POINT_EXPORT_NEW = "ACCESS_POINT_EXPORT_NEW",
    ACCESS_POINT_EXPORT_STARTED = "ACCESS_POINT_EXPORT_STARTED",
    ACCESS_POINT_EXPORT_NEED_CONFIRM = "ACCESS_POINT_EXPORT_NEED_CONFIRM",
    ACCESS_POINT_EXPORT_COMPLETED = "ACCESS_POINT_EXPORT_COMPLETED",
    ACCESS_POINT_EXPORT_FAILED = "ACCESS_POINT_EXPORT_FAILED",
}
